module.exports = __webpack_public_path__ + "static/img/氨解仪整体展示.8904a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/仪器设备/氨解仪/氨解仪整体展示.png
// module id = bwmT
// module chunks = 16